<template>
  <div
    class="c-loader--container l-flex"
    aria-label="loading content"
  >
    <div class="c-loader" />
  </div>  
</template>

<script>

export default {
  name: 'Loader',
};
</script>

<style lang="scss" scoped>
  .c-loader {
    display: inline-block;
    width: 80px;
    height: 80px;

    &:after {
      content: " ";
      display: block;
      width: 64px;
      height: 64px;
      margin: 8px;
      border-radius: 50%;
      @include themify($themes) {
        border: 6px solid themed('foreground');
        border-color: themed('foreground') transparent themed('foreground') transparent;
      }
      animation: loader 1.2s linear infinite;
    }
  }

  @keyframes loader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

</style>
